<template>
	<transition name="fade">
		<div class="popup-wrap fixed-100">
            <div class="popup-text center-middle">
                <h4 class="popup-h">{{title}}</h4>
				<i @click="confirm" class="popup-close"></i>
                <slot></slot>
                <button class="popup-btn" @click="confirm">确定</button>
            </div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'popup',
		props: {
            title: {
                type: String,
                default: "提示"
            }
		},
		data () {
			return {}
		},
        methods: {
			confirm(){
				this.$emit("close");
			}
        }
	}
</script>

<style scoped>
	.center-middle{
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: scale(1, 1) translate(-50%, -50%);
		-moz-transform: scale(1, 1) translate(-50%, -50%);
		transform: scale(1, 1) translate(-50%, -50%);
	}
	.popup-wrap {
		z-index: 9999;
		background-color: rgba(0,0,0,0.4);
	}
	.popup-wrap  .popup-text {
		max-width: 6.4rem;
		width:6.4rem;
		background: #fff;
		color: #000;
		text-align: center;
		z-index: 9999;
	}
	.popup-text::before{
		content: '';
		display: block;
		height: 0.09rem;
		background: #EB2221;
	}
	.fade-enter-active,.fade-leave-active {
		transition: 0.3s ease-out;
	}
	.fade-enter {
		opacity: 0;
		transform: scale(1.2);
	}
	.fade-leave-to {
		opacity: 0;
		transform: scale(0.8);
	}
	.popup-btn{
		margin: 0.4rem 0;
		background: #EB2221;
		border-radius: 0.36rem;
		border: 0;
		width: 2.4rem;
		height: 0.72rem;
		color: #fff;
		font-size: 0.28rem;
	}
	.popup-close{
		position: absolute;
		width: 0.4rem;
		height: 0.4rem;
		top: 0.3rem;
		right: 0.3rem;
		background: url("../../../assets/images/ico/ico-close.png") no-repeat;
		background-size: 100% 200%;
		background-position-y: 100%;
		z-index: 1000;
	}
	.popup-h{
		padding: 0.4rem 0 0.28rem 0;
		font-size: 0.34rem;
		font-weight: 700;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/popup/index.vue